import { cUtil } from "../../functions/util";

export function getPrice(
  date       : string,
  type       : 'effective' | 'regular' | 'sale',
  prices     : CurrentPrice[]
): CurrentPrice {
  
  if(date === '') date = cUtil.currentIsoDateCET();

  const currentPrices = prices.filter(price => price.fromDate <= date && price.toDate >= date);
  const customerPrice = currentPrices.find(price => price.isIndvidualPrice);
  const salesPrice    = currentPrices.find(price => price.isOnSale);
  const regularPrice  = currentPrices.find(price => !price.isOnSale && !price.isIndvidualPrice);

  if (type === 'regular') {
    return (
      customerPrice ??
      regularPrice  ??
      createEmptyPrice()
    );
  }

  if (type === 'sale') {
    return (
      salesPrice ??
      createEmptyPrice()
    );
  }

  return (
    customerPrice ??
    salesPrice    ??
    regularPrice   ??
    createEmptyPrice()
  );
}

function createEmptyPrice(): CurrentPrice {
  return {
    price                    : 0,
    isOnSale                 : false,
    isIndvidualPrice         : false,
    fromDate                 : '',
    toDate                   : '',
    productVisible           : false,
  };
}
